"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_IS_DEFAULTED_LOAN_ACTIVE_URL = void 0;
exports.default = 'accounts/login/';
exports.UPDATE_IS_DEFAULTED_LOAN_ACTIVE_URL = 'accounts/officers/update-is-defaulted-loan-active/';
